import { infoTypes } from '../constants.js';
import {
  formatModifiedDateWithLabel,
  formatPublishedDateWithLabel,
} from './get-info-labels.js';

function getInfo({ articleData, author, infoType, i18next }) {
  const pubDateLabel = formatPublishedDateWithLabel(
    articleData.publicationDate,
    i18next,
  );

  switch (infoType) {
    case infoTypes.PUBLICATION_DATE:
    case infoTypes.AUTHOR_AND_PUBLICATION_DATE:
      return pubDateLabel;
    case infoTypes.AUTHOR:
      return author?.title || '';
    case infoTypes.READING_TIME:
    case infoTypes.AUTHOR_AND_READING_TIME:
      return articleData.readingTime;
    default:
      const { modifiedDate } = articleData;

      if (modifiedDate) {
        return formatModifiedDateWithLabel(modifiedDate, i18next);
      }

      return pubDateLabel;
  }
}

export default getInfo;
